module.exports = __webpack_public_path__ + "img/goods9_4.06afc08e.jpg";